<template>
    <div class="row mx-auto my-2 py-4">
        <div class="col-md-3 p-0 mx-auto">
          <qr-maker></qr-maker>
        </div>
        <div class="col-md mx-auto p-3">
            <div class="row mx-auto">
                <v-expansion-panels class="px-1">
                    <v-expansion-panel class="mb-1">
                        <v-expansion-panel-header class="text-right">
                            skype
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <div class="col-md-12 mx-auto">
                                <v-radio-group class="mt-0 pt-0 px-0 mx-0" row v-model="data.kind">
                                    <v-radio
                                            value="chat"
                                            :label="$t('chat')"
                                    >
                                    </v-radio>
                                    <v-radio
                                            :label="$t('call')"
                                            value="call"
                                            class="my-2"
                                    ></v-radio>
                                </v-radio-group>
                                <v-text-field outlined
                                              dense
                                              v-model="data.userName"
                                              :hint="$t('please_enter_username')"
                                              maxLength="50"
                                              counter="50"
                                              :label="$t('username')"
                                              append-icon="mdi-domain"/>
                            </div>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </div>
            <qr-generator></qr-generator>
        </div>
    </div>
</template>

<script>
import QrGenerator from "./qrGenerator";
import QrMaker from "./qrMaker";
export default {
    name: "qrSkype",
    components: {QrMaker, QrGenerator},
    data(){
        return{
            data:{
                kind:'chat',
                userName:''

            }
        }
    }
}
</script>

<style scoped>

</style>